<template>
    <v-card tile flat class="MyTrading" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
        <v-container>
            <v-row dense>
                <v-col cols="12">
                    <v-sheet class="d-flex align-center mb-4" :color="$vuetify.theme.dark ? '#162334 ' : 'transparent'
                        ">
                        <div class="title">
                            <v-icon dense color="#5F7692">mdi-bag-checked</v-icon>
                            <span class="ml-2">My Tradings</span>
                        </div>
                    </v-sheet>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                    <v-sheet :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                        <v-card-text class="d-flex pt-2 trade pb-0">
                            <div class="d-flex align-start">
                                <v-icon class="blink" color="#FF567F">
                                    mdi-circle-small
                                </v-icon>
                                <p class="ma-0">
                                    Live Trades
                                    <br />
                                    <span>Lot:
                                        {{
                                            account_summary?.liveTradesTotalLot|| 0
                                        }}</span>
                                </p>
                            </div>
                            <v-spacer></v-spacer>
                            <router-link class="links" to="/trading-details?tab=1">See All ></router-link>
                        </v-card-text>
                        <v-card-text class="d-flex pl-6 pb-2 trade align-center">
                            <span class="number">{{ account_summary?.liveOrders || 0 }}</span>
                            <v-spacer></v-spacer>
                            <span class="equity">Equity:
                                <strong>{{
                                    account_summary?.liveTradesTotalEquity || 0
                                }}
                                </strong></span>
                        </v-card-text>
                    </v-sheet>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                    <v-sheet :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                        <v-card-text class="d-flex pt-2 trade pb-0">
                            <div class="d-flex align-start">
                                <v-icon large color="#708AA7">
                                    mdi-circle-small
                                </v-icon>
                                <v-spacer></v-spacer>
                                <p class="ma-0">
                                    Closed Trades
                                    <br />
                                    <span>Lot:
                                        {{
                                            account_summary?.closedTradesTotalLot || 0
                                        }}</span>
                                </p>
                            </div>
                            <v-spacer></v-spacer>
                            <router-link class="links" to="/trading-details?tab=2">See All ></router-link>
                        </v-card-text>
                        <v-card-text class="d-flex pl-6 pb-2 trade align-center">
                            <span class="number closed-number">{{
                                account_summary?.totalClosedTrades || 0
                            }}</span>
                            <v-spacer></v-spacer>
                            <span class="equity">Profit:
                                <strong>{{
                                    account_summary?.totalProfit?.toFixed(
                                        2
                                    ) || 0
                                }}
                                    USD</strong></span>
                        </v-card-text>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import { PROFILE__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
    name: "balanceCard",
    components: {},
    data() {
        return {};
    },
    computed: {
        ...mapState("account", ["account_summary"]),
        ...mapState("livetrades", ["total"]),
    },
    methods: {
        ...mapActions("account", [PROFILE__ACTIONS.ACCOUNTSUMMARY]),
        ...mapActions("livetrades", [PROFILE__ACTIONS.LIVETRADES]),
    },
    async mounted() {
        try {
            await this[PROFILE__ACTIONS.ACCOUNTSUMMARY]();
            await this[PROFILE__ACTIONS.LIVETRADES]();
        } catch (error) {
            console.log(error);
        }
    },
};
</script>
